import { useEffect, useRef } from 'react';

/**
 * A validation message can sit far below the control that caused it, and the
 * panel gives no sign of it, so pressing the button looks like it did nothing.
 * Returns a ref for the container to search: when `hasError` turns on, its
 * first error message scrolls into view.
 */
export function useScrollToFirstError<T extends HTMLElement>(
  hasError: boolean
) {
  const containerRef = useRef<T>(null);
  useEffect(() => {
    if (!hasError) return;
    // jsdom has no scrollIntoView.
    containerRef.current
      ?.querySelector('.ant-form-item-explain-error')
      ?.scrollIntoView?.({ behavior: 'smooth', block: 'nearest' });
  }, [hasError]);
  return containerRef;
}
